<template lang="html">
  <v-content>
    <v-dialog
      width="500"
      v-model="deleteConfirmationDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      @keydown.esc="deleteConfirmationDialogOpened = false"
    >
      <v-card flat v-if="selectedReminder">
        <v-card-title class="title"> Confirmation </v-card-title>
        <v-card-text class="text-xs-left subheading">
          <v-alert type="error" :value="true" outline>
            Are you sure you want to delete the reminder about
            {{ selectedReminder.reference_name }}?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="removeReminder(selectedReminder)"
          >
            Yes
          </v-btn>
          <v-btn
            class="text-capitalize error--text"
            outline
            @click="deleteConfirmationDialogOpened = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="500"
      v-model="deleteMultipleConfirmationDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      @keydown.esc="deleteMultipleConfirmationDialogOpened = false"
    >
      <v-card flat>
        <v-card-title class="title"> Confirmation </v-card-title>
        <v-card-text class="text-xs-left subheading">
          <v-alert type="error" :value="true" outline>
            Are you sure you want to delete
            {{ selectedReminders.length }} reminders?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="deleteMultipleReminders()"
          >
            Yes
          </v-btn>
          <v-btn
            class="text-capitalize error--text"
            outline
            @click="deleteMultipleConfirmationDialogOpened = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      @keydown.esc="reminderDialogOpened = false"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="reminderDialogOpened"
      max-width="700px"
    >
      <v-card>
        <v-card-title class="title"> Add Reminder </v-card-title>
        <v-card-text>
          <v-layout class="text-xs-left">
            <v-flex xs4 class="pr-2">
              <div>
                Remind me on
                <!-- <v-tooltip top><v-icon slot="activator" size="15" class="ml-1">info</v-icon><span>Reminders will be sent out automatically to incomplete questionnaire approaching the due date</span></v-tooltip> -->
              </div>
              <v-text-field
                class="default-input body-1"
                type="date"
                solo
                hide-details
                :rules="reminderDateRules"
                v-model="reminderTime"
                placeholder="Choose a date"
              />
            </v-flex>
            <v-flex xs8 class="pl-2">
              <div>
                Reminder
                <!-- <v-tooltip top><v-icon slot="activator" size="15" class="ml-1">info</v-icon><span>Reminders will be sent out automatically to incomplete questionnaire approaching the due date</span></v-tooltip> -->
              </div>
              <v-text-field
                class="default-input body-1"
                solo
                hide-details
                v-model="reminderText"
                placeholder="Start tax planning"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer class="hidden-xs-only" />
          <v-btn
            class="default-input primary text-capitalize"
            @click="addReminder()"
            :disabled="!isReminderSavable"
            :loading="reminderSaving"
          >
            Add
          </v-btn>
          <v-btn
            outline
            class="default-input error--text text-capitalize"
            @click="reminderDialogOpened = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="max-width: 1000px"
      @drop.prevent="addFile"
      @dragover.prevent
    >
      <v-layout class="mb-2" align-center>
        <soraban-action-button
          @click="$router.go(-1)"
          icon="keyboard_arrow_left"
          help="Back"
          v-if="$vuetify.breakpoint.smAndUp"
        />
        <h1>My Reminders</h1>
        <v-spacer />
        <soraban-action-button
          @click="getReminders()"
          icon="cached"
          help="Refresh"
        />
        <soraban-action-button
          @click="openAddReminderDialog()"
          icon="add"
          help="Add Reminder"
        />
        <soraban-action-button
          @click="deleteMultipleConfirmationDialogOpened = true"
          v-if="!isEmpty(selectedReminders)"
          icon="delete"
          :help="`Deleted Selected (${selectedReminders.length})`"
        />
        <!-- <soraban-action-button
          @click="openTaxSoftwareIntegrationDialog()"
          icon="cable"
          help="Connect Tax Software"
          :disabled="currentUser.firm_access !== 'partner'"
        /> -->
      </v-layout>
      <v-card flat class="content-container pt-3">
        <!-- <v-divider class="separator" /> -->
        <v-card-text>
          <!-- <v-flex v-if="currentUser.is_advisor">
            <v-alert :value="true" outline block type="info" class="text-xs-left">
              You can add files by clicking on the add icon on the right or just by dragging and dropping files to this section. Do not include slashes (/) or periods (.) when renaming files.
            </v-alert>
          </v-flex> -->
          <v-layout class="subheading pb-2" align-center justify-center>
            <v-spacer class="hidden-sm-and-down" />
            <v-flex xs6>
              <v-text-field
                v-model="reminderSearch"
                append-icon="search"
                label="Search"
                single-line
                placeholder="Search"
                hide-details
                solo
                class="default-input"
              />
            </v-flex>
          </v-layout>
          <v-layout column>
            <v-data-table
              :headers="reminderHeaders"
              :pagination.sync="reminderPagination"
              :items="reminders"
              :loading="loading"
              :search="reminderSearch"
              class="documents-table"
              :select-all="$vuetify.breakpoint.mdAndUp"
              v-model="selectedReminders"
              item-key="name"
            >
              <template slot="headerCell" slot-scope="props">
                <template v-if="props.header.text === 'Persistent?'">
                  <v-tooltip bottom>
                    <template slot="activator">
                      <v-layout align-center>
                        {{ props.header.text }}
                        <v-icon size="15" class="ml-1"> help_outline </v-icon>
                      </v-layout>
                    </template>
                    <span>
                      Keep the reminder after new action (e.g. new message)
                    </span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <span>
                    {{ props.header.text }}
                  </span>
                </template>
              </template>
              <template slot="items" slot-scope="props">
                <tr :key="props.index">
                  <td class="hidden-sm-and-down" style="max-width: 10px">
                    <v-checkbox
                      v-model="props.selected"
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="text-xs-left primary--text">
                    <div
                      style="cursor: pointer"
                      @click="openReminderLink(props.item)"
                    >
                      {{ props.item.reference_name }}
                    </div>
                  </td>
                  <td class="text-xs-left">
                    <span class="documents-row__updated-date">{{
                      moment(props.item.scheduled_time).format('lll')
                    }}</span>
                  </td>
                  <td class="text-xs-center">
                    <v-icon
                      v-if="props.item.reference_type && props.item.persistent"
                      color="success"
                    >
                      done
                    </v-icon>
                    <v-icon
                      v-else-if="
                        props.item.reference_type && !props.item.persistent
                      "
                      color="error"
                    >
                      clear
                    </v-icon>
                    <div v-else class="grey--text text--darken-1">-</div>
                  </td>
                  <td>
                    <i
                      slot="activator"
                      class="material-icons-outlined error--text"
                      style="cursor: pointer"
                      @click="openDeleteConfirmationDialog(props.item)"
                    >
                      delete
                    </i>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-layout class="text-xs-center grey--text">
                  <v-flex>
                    <v-icon size="16" color="grey"> priority_high </v-icon>
                    <span class="ml-1">No Reminders</span>
                  </v-flex>
                </v-layout>
              </template>
            </v-data-table>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import take from 'lodash/take';
import get from 'lodash/get';

export default {
  name: 'MyReminders',
  data() {
    return {
      reminderDialogOpened: false,
      reminderTime: null,
      reminderPersistent: false,
      reminderDateRules: [
        v => moment() < moment(v) || !v || 'Due date must be in the future',
      ],
      createReminderDialogOpened: false,
      deleteConfirmationDialogOpened: false,
      deleteMultipleConfirmationDialogOpened: false,
      reminderHeaders: [
        {
          text: 'Reminder',
          align: 'left',
          sortable: true,
          value: 'reference_name',
          width: '50%',
        },
        {
          text: 'Remind me at',
          align: 'left',
          sortable: true,
          value: 'scheduled_time',
          width: '30%',
        },
        {
          text: 'Persistent?',
          align: 'center',
          sortable: false,
          value: 'persistent',
          width: '10%',
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
          width: '10%',
        },
      ],
      reminderPagination: {
        sortBy: 'scheduled_time',
        rowsPerPage: 10,
        descending: false,
        page: 1,
        options: [
          {
            text: '10 rows per page',
            value: 10,
          },
          {
            text: '20 rows per page',
            value: 20,
          },
          {
            text: '30 rows per page',
            value: 30,
          },
        ],
      },
      reminders: [],
      reminderSaving: false,
      reminderText: '',
      reminderSearch: '',
      selectedReminders: [],
      selectedReminder: null,
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      currentUser: 'user',
      isAdvisor: 'isAdvisor',
    }),
    isReminderSavable() {
      return moment() < moment(this.reminderTime);
    },
  },
  methods: {
    moment,
    get,
    isEmpty,
    openAddReminderDialog() {
      // NOTE @chris This does nothing currently (was `return commandbar.execute(3335)` before) & nothing points to this page.
    },
    async addReminder() {
      try {
        this.reminderDialogOpened = false;
        const response = await API.reminder.addReminder({
          reminderText: this.reminderText,
          time: this.reminderTime,
          persistent: this.reminderPersistent,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem adding the reminder.',
          });
          console.log(e);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: "You've added a reminder.",
          });
          this.getReminders();
        }
      } catch (e) {
        console.log(e);
      }
    },
    openReminderLink(reminder) {
      if (reminder.reference_type === 'Conversation') {
        this.$emit('openSpecificConversation', reminder.reference_id);
      }
    },
    openDeleteConfirmationDialog(reminder) {
      this.selectedReminder = reminder;
      this.deleteConfirmationDialogOpened = true;
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    async deleteMultipleReminders() {
      try {
        this.loading = true;
        this.deleteMultipleConfirmationDialogOpened = false;
        await this.asyncForEach(this.selectedReminders, async reminder => {
          const response = await API.reminder.removeReminder(reminder.id);
        });
        this.$store.dispatch('application/setSuccessNotification', {
          message: "You've deleted the reminders",
        });
        await this.getReminders();
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem deleting the reminders.',
        });
      } finally {
        this.loading = false;
      }
    },
    async removeReminder(reminder) {
      try {
        this.deleteConfirmationDialogOpened = false;
        this.loading = true;
        const response = await API.reminder.removeReminder(reminder.id);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem removing the reminder.',
          });
          console.log(e);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: "You've removed the reminder.",
          });
          this.getReminders();
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async getReminders() {
      try {
        this.loading = true;
        const response = await API.reminder.getMyReminders();
        this.reminders = response.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.getReminders();
  },
};
</script>

<style lang="postcss" scoped>
.documents {
  &__icon {
    font-size: 18px;
  }
}
.document-action {
  &__icon {
    font-size: 20px;
  }
}
.documents-row {
  &__updated-date {
    font-weight: 200;
    color: rgba(9, 30, 66, 0.6);
  }
}
.image-holder {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
</style>
